import { Sector } from '@/domain/impact/impact.entity';

// TODO proposition de refactor :
// les props label / score / tags sont dans toutes les questions CO2
// elles ont était placé dans le type Values***
// idée : déplacer ces 3 props dans le type partager ImpactCo2Answer

export type ImpactCo2Answer<
  T extends
    | unknown
    | ValuesAccommodation
    | ValuesAccommodationPublic
    | ValuesBuilding
    | ValuesCargo
    | ValuesCateringBeverage
    | ValuesCateringMeal
    | ValuesDigital
    | ValuesEnergy
    | ValuesEquipment
    | ValuesGenerator
    | ValuesMobility
    | ValuesMobilityPublic
    | ValuesNonRecyclableWaste
    | ValuesRecyclableWaste
    | ValuesScenographyNoRecyclable
    | ValuesScenographyRecyclable
    | ValuesBuildingHeating
    | ValuesOfficeSuppliesNew
    | ValuesOfficeSuppliesRefurbish
    | ValuesTeamMobility
    | ValuesWater = unknown,
> = {
  id: number;
  userId: string;
  sector: Sector;
  category: Category;
  isExternal: boolean;
  source: Source;
  values: T;
};

export type ValuesAccommodation = {
  accommodationType: AccommodationType;
  numberOfNights: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesAccommodationPublic = {
  accommodationType: AccommodationType;
  numberOfNights: number;
  guestCount: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesBuilding = {
  hasBuildingImpact: boolean;
  buildingCarbonImpactPerDay: number;
  numberOfDaysOfUse: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesCargo = {
  transportationMode: CargoType;
  weight: number;
  travelDistance: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesCateringBeverage = {
  beverageType: BeverageType;
  beverageCount: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesCateringMeal = {
  mealType: MealType;
  mealCount: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesDigital = {
  dataUsage: number;
  videoViews: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesEnergy = {
  energyType: EnergyType;
  energyConsumptionQuantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesEquipment = {
  rentedEquipmentType: EquipmentType;
  rentalDays: number;
  quantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesGenerator = {
  hasGenerator: boolean;
  fuelType: FuelType;
  fuelConsumption: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesMobility = {
  transportationMode: TransportationMode;
  passengerCount: number;
  travelDistance: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesMobilityPublic = {
  transportationMode: TransportationMode;
  passengerCount: number;
  travelDistance: number;
  departurePoint: string;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesNonRecyclableWaste = {
  nonRecyclableWasteType: NonRecyclableWasteType;
  nonRecyclableWasteQuantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesRecyclableWaste = {
  recyclableWasteType: RecyclableWasteType;
  recyclableWasteQuantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};
export type ValuesScenographyNoRecyclable = {
  scenographieNoRecyclableType: ScenographieNoRecyclableType;
  quantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesScenographyRecyclable = {
  scenographieRecyclableType: ScenographieRecyclableType;
  quantity: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesBuildingHeating = {
  buildingHeatingType: BuildingHeatingType;
  buildingSize: number;
  numberOfMonthsOfUse: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesOfficeSuppliesNew = {
  officeSuppliesNewType: OfficeSuppliesNewType;
  count: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesOfficeSuppliesRefurbish = {
  officeSuppliesRefurbishType: OfficeSuppliesRefurbishType;
  count: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesTeamMobility = {
  transportationMode: TransportationMode;
  passengerCount: number;
  travelDistance: number;
  numberOfDays: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

export type ValuesWater = {
  waterConsumptionVolume: number;
  label?: string;
  score: number;
  tags: Array<{ id: number; name: string }>;
};

// -------------

export enum Co2Section {
  MOBILITY = 'MOBILITY',
  CATERING = 'CATERING',
  ACCOMMODATION = 'ACCOMMODATION',
  CARGO = 'CARGO',
  DIGITAL = 'DIGITAL',
  ENERGY = 'ENERGY',
  WATER = 'WATER',
  WASTE = 'WASTE',
  EQUIPMENT = 'EQUIPMENT',
  BUILDING = 'BUILDING',
  SCENOGRAPHY = 'SCENOGRAPHY',
  MATERIAL = 'MATERIAL',
  TRANSPORT = 'TRANSPORT',
}

export type Category = (typeof CategoryValues)[number];
export const CategoryValues = [
  'ACCOMMODATION',
  'ACCOMMODATION_PUBLIC',
  'BUILDING',
  'CARGO',
  'CATERING_BEVERAGE',
  'CATERING_MEAL',
  'ENERGY',
  'EQUIPMENT',
  'GENERATOR',
  'MOBILITY',
  'MOBILITY_PUBLIC',
  'DIGITAL',
  'NON_RECYCLABLE_WASTE',
  'RECYCLABLE_WASTE',
  'WATER',
  'SCENOGRAPHY_NO_RECYCLABLE',
  'SCENOGRAPHY_RECYCLABLE',
  'OFFICE_SUPPLIES_NEW',
  'OFFICE_SUPPLIES_REFURBISH',
  'BUILDING_HEATING',
  'TEAM_MOBILITY',
] as const;

export type Source = (typeof SourceValues)[number];
export const SourceValues = [
  '',
  'PRESET',
  'DECLARATION',
  'IMPORT_THEGREENSHOT',
  'SURVEY',
] as const;

// -------------

export type AccommodationType = (typeof AccommodationTypeValues)[number];
export const AccommodationTypeValues = [
  'HOTEL',
  'CAMPING',
  'HOSTED',
  'RENTING',
] as const;

export type BeverageType = (typeof BeverageTypeValues)[number];
export const BeverageTypeValues = [
  'BEER',
  'WINE',
  'MONOFRUIT_JUICE',
  'MULTIFRUIT_JUICE',
  'SOFT_DRINK',
  'PLASTIC_BOTTLED_WATER',
  'PURE_JUICE',
  'SODA',
] as const;

export type EnergyType = (typeof EnergyTypeValues)[number];
export const EnergyTypeValues = [
  'ELECTRICITY_NETWORK_FRANCE',
  'ELECTRICITY_NETWORK_OUTSIDE_FRANCE',
  'GAS',
  'FUEL_OIL',
  'LOGS',
  'WOOD_PELLETS',
  'PHOTOVOLTAIC_ELECTRICITY',
  'WOOD',
] as const;

export type EquipmentType = (typeof EquipmentTypeValues)[number];
export const EquipmentTypeValues = [
  'PROJECTORS',
  'SPEAKERS',
  'CONSOLES',
  'SMOKE_MACHINES',
  'MICROPHONES',
  'VIDEO_PROJECTORS',
  'AD_SCREENS',
] as const;

export type FuelType = (typeof FuelTypeValues)[number];
export const FuelTypeValues = [
  'PETROL',
  'DIESEL',
  'BIODIESEL',
  'USED_COOKING_OIL',
] as const;

export type MealType = (typeof MealTypeValues)[number];
export const MealTypeValues = [
  'AVERAGE_MEAL',
  'MEAL_WITH_RED_MEAT_BEEF',
  'MEAL_WITH_WHITE_MEAT_CHICKEN',
  'FISH',
  'VEGETARIAN',
  'VEGAN',
] as const;

export type NonRecyclableWasteType =
  (typeof NonRecyclableWasteTypeValues)[number];
export const NonRecyclableWasteTypeValues = [
  'END_OF_LIFE_GLASS',
  'CARDBOARD',
  'PLASTIC',
  'HOUSEHOLD_WASTE',
  'WOOD',
  'ALUMINIUM',
  'MIXED_BATTERIES',
  'ORGANIC_WASTE',
  'WASTE_WATER',
] as const;

export type RecyclableWasteType = (typeof RecyclableWasteTypeValues)[number];
export const RecyclableWasteTypeValues = [
  'GLASS',
  'CARDBOARD',
  'PLASTIC',
  'ALUMINIUM',
  'MIXED_BATTERIES',
  'ORGANIC_WASTE',
  'WEEE_WASTE',
] as const;

export type TransportationMode = (typeof TransportationModeValues)[number];
export const TransportationModeValues = [
  'BICYCLE',
  'ELECTRIC_BICYCLE',
  'ELECTRIC_SCOOTER',
  'SUBWAY_TRAMWAY',
  'MOTOR_CAR_VAN_TAXI_VEHICLE',
  'MINIBUS_VAN',
  'ELECTRIC_CAR_VAN_TAXI_VEHICLE',
  '2_WHEEL_MOTORIZED_VEHICLE',
  'INTER_CITY_TRAIN',
  'REGIONAL_TRAIN',
  'TRAIN_IN_FRANCE',
  'TRAIN_IN_FRANCE_AND_EUROPE',
  'TRAIN_IN_EUROPE',
  'FERRY',
  'SHORT_HAUL_FLIGHT',
  'MEDIUM_HAUL_FLIGHT',
  'LONG_HAUL_FLIGHT',
  'COACH',
  'BUS',
  'TOURBUS',
  'CARPOOLING_MOTOR_VEHICLE',
  'CARPOOLING_ELECTRIC_VEHICLE',
] as const;

export type ScenographieNoRecyclableType =
  (typeof ScenographieNoRecyclableValues)[number];
export const ScenographieNoRecyclableValues = [
  'TEXTILE_AND_CLOTHING',
  'NEW_STEEL',
  'NEW_ALUMINIUM',
  'NEW_CARDBOARD',
  'NEW_PAPER',
  'NEW_PLASTIC',
  'NEW_GLASS',
] as const;

export type ScenographieRecyclableType =
  (typeof ScenographieRecyclableValues)[number];
export const ScenographieRecyclableValues = [
  'RECYCLABLE_ALUMINIUM',
  'WOOD',
  'RECYCLABLE_CARDBOARD',
  'RECYCLABLE_PAPER',
  'RECYCLABLE_PLASTIC',
  'RECYCLABLE_GLASS',
  'RECYCLABLE_STEEL',
] as const;

export type OfficeSuppliesNewType = (typeof OfficeSuppliesNewValues)[number];
export const OfficeSuppliesNewValues = [
  'LAPTOP',
  'COMPUTER',
  'SCREEN_21',
  'SCREEN_23',
  'PROJECTOR',
  'SMALL_TABLET',
  'SMARTPHONE',
  'BLUETOOTH_SPEAKER',
  'CLASSIC_STEREO',
  'PRINTER_INK',
  'PRINTER_LASER',
  'PHOTOCOPIER',
  'MODEM',
] as const;

export type OfficeSuppliesRefurbishType =
  (typeof OfficeSuppliesRefurbishValues)[number];
export const OfficeSuppliesRefurbishValues = [
  'REFURBISH_COMPUTER',
  'REFURBISH_PHOTOCOPIER',
  'REFURBISH_SMARTPHONE',
  'REFURBISH_PROJECTOR',
] as const;

export type BuildingHeatingType = (typeof BuildingHeatingValues)[number];
export const BuildingHeatingValues = [
  'HEATING_OFFICES',
  'HEATING_CONCERT_HALL',
  'HEATING_REPEATS_HALL',
] as const;

export type CargoType = (typeof CargoValues)[number];
export const CargoValues = [
  'VAN',
  'TRUCK',
  'SEMI_TRAILER',
  'TRAIN_IN_FRANCE',
  'FERRY',
  'CARGO_PLANE',
] as const;
